import _ from 'lodash';
import LocalizedStrings from 'react-localization';

import LanguageJson from './lang_en.json';
import LanguageExtraJson from './lang_en_extra.json';

// --------- NOTE -----------
// IF UPDATING LANGUAGE FILE ONLY UPDATE THE TEXTS NOT THE DOUBLE QUOTES ('') OR BACK-TICS (``)

const LocalStrings = new LocalizedStrings({
  en: {
    extra: {
      ..._.cloneDeep(LanguageExtraJson)
    },
    dynamic: {
      ..._.cloneDeep(LanguageJson),

      kOpenText: 'Open',
      kClosedText: 'Closed',

      // These keys are required in web portal and removed from lang_file. These are dynamic, gets replaced and no translation required.
      kNewsText: 'News',
      kCommunityText: 'Community',
      kSocialText: 'Social',
      kWebviewText: 'Webview',
      kEventguideText: 'Event Guide',
      kMyItinerary: 'My Itinerary'
    }
  }
});

// module.exports = LocalStrings;
export default LocalStrings;
